import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: { isEditing: boolean; isAssignedToChanged: boolean; isEditSheetOpen: boolean } =
    {
        isEditing: false,
        isAssignedToChanged: false,
        isEditSheetOpen: false,
    };

export const editDocumentSlice = createSlice({
    name: "editDocument",
    initialState,
    reducers: {
        setIsEditing: (state, action: PayloadAction<boolean>) => {
            state.isEditing = action.payload;
        },
        setIsAssignedToChanged: (state, action: PayloadAction<boolean>) => {
            state.isAssignedToChanged = action.payload;
        },
        setIsEditSheetOpen: (state, action: PayloadAction<boolean>) => {
            state.isEditSheetOpen = action.payload;
            state.isEditing = false;
        },
    },
});

export const { setIsEditing, setIsAssignedToChanged, setIsEditSheetOpen } =
    editDocumentSlice.actions;

export const editDocumentReducer = editDocumentSlice.reducer;
export default editDocumentSlice.reducer;
